import { BlobServiceClient } from "@azure/storage-blob";

import { authProvider } from '../utils/authProvider';
export default class BlobUtil{
    account:string = "ultimatesprodevstorage01";
    sas:string = "";//"?sv=2019-02-02&ss=bfqt&srt=sco&sp=rwdlacup&se=2020-05-08T17:28:43Z&st=2020-03-01T09:28:43Z&spr=https,http&sig=tWLpfYce3QaCDn5olzSyD0cV233lsX7XO3VpOP2t%2B1o%3D";
    courseSas:string = "";
    containerName:string ="";
    blobServiceClient:any;
    /**
     *
    constructor() {
      //let accountInfo = authProvider.getAccountInfo();
      //console.log(accountInfo?.jwtIdToken);
      // fetch("https://ultimatesprodevapilx01.azurewebsites.net/api/GetUserFaceBlobContainerSAS?code=Up5ZaGypEo2I0FMqvUCKDAM1PcIaFXMLWsVn6kjbP8xwGinljjxxtw==",
      //   {method:"get",
      //   headers:new Headers({
      //     "Authorization":"Bearer " + accountInfo?.jwtIdToken,
      //     "Content-Type":"application/json"
      //   })}
      // ).then(
      //   data =>{

      //     console.log(data);
      //     data.text().then( (sas2:any)=>{
      //       this.containerName = "user-" + accountInfo?.account.accountIdentifier;
      //       //console.log(sas2);
      //       this.sas = sas2;
      //       this.blobServiceClient = new BlobServiceClient(`https://${this.account}.blob.core.windows.net?${sas2}`            );
      //     })
      //   } 
      // );
    } 

     */

    public async GenerateSARSToken():Promise<string>{
      let accountInfo = authProvider.getAccountInfo();
      if (this.sas != ''){
        return this.sas;
      }else{
        return await fetch("https://ultimatesprodevapilx01.azurewebsites.net/api/GetUserFaceBlobContainerSAS?code=Up5ZaGypEo2I0FMqvUCKDAM1PcIaFXMLWsVn6kjbP8xwGinljjxxtw==",
          {method:"get",
          headers:new Headers({
            "Authorization":"Bearer " + accountInfo?.jwtIdToken,
            "Content-Type":"application/json"
          })}
        ).then(
          data =>{
            //console.log(data);
            return data.text().then( 
              (sas2:any)=>{
              this.containerName = "user-" + accountInfo?.account.accountIdentifier;
              //console.log("oId : "+  accountInfo?.account.accountIdentifier);
              this.sas = sas2;
              const _url = "https://" +this.account + ".blob.core.windows.net?" +this.sas;
              this.blobServiceClient = new BlobServiceClient(_url);
              
              return this.sas;
            });
          } 
        );
      }
    }

    public async GenerateCourseSARSToken():Promise<string>{
      let accountInfo = authProvider.getAccountInfo();
      if (this.courseSas != ''){
        return this.courseSas;
      }else{
        return await fetch("https://ultimatesprodevapilx01.azurewebsites.net/api/GetCourseBlobContainerSAS?code=KpwrmLgvVffIBKZrUnWc7r/OexS/Ob4Tn/IOhjxGaWmPy2/ID6LJEg==",
          {method:"get",
          headers:new Headers({
            "Authorization":"Bearer " + accountInfo?.jwtIdToken,
            "Content-Type":"application/json"
          })}
        ).then(
          data =>{
            // console.log(data);
            return data.text().then( 
              (sas2:any)=>{
                this.courseSas = sas2;
                return this.courseSas;
            });
          } 
        );
      }
    }
    
    
    public async Upload(filename:string,content:any, metadata?:any):Promise<string> {
      try {
        let blobSarsToken = await this.GenerateSARSToken();

        let containerClient = this.blobServiceClient.getContainerClient(this.containerName);
        let blockBlobClient  = containerClient.getBlockBlobClient(filename);
        //blockBlobClient.Properties.ContentType = "image/png";
        let uploadBlobResponse = await blockBlobClient.upload(content,content.length,{
          blobHTTPHeaders: {blobContentType:"image/jpg"

            },
          metadata: metadata === undefined ?{}:metadata
        });
        return uploadBlobResponse._response.request.url;
  
      } catch (error) {
          //console.log(error);
          throw error;
      }
    }
    public async UploadBlob(filename:string,content:any,contentType:string , metadata?:any ):Promise<string> {
      try {
        let blobSarsToken = await this.GenerateSARSToken();

        let containerClient = this.blobServiceClient.getContainerClient(this.containerName);
        let blockBlobClient  = containerClient.getBlockBlobClient(filename);
        //blockBlobClient.Properties.ContentType = "image/png";
        let uploadBlobResponse = await blockBlobClient.uploadBrowserData(content,{
          blobHTTPHeaders: {blobContentType:contentType

            },
          metadata: metadata === undefined ?{}:metadata
        });
        return uploadBlobResponse._response.request.url;
  
      } catch (error) {
          //console.log(error);
          throw error;
      }
    }

    public async GetBlob(filename:string):Promise<string> {
      try {
        let blobSarsToken = await this.GenerateSARSToken();
        let accountInfo = authProvider.getAccountInfo();
        var containerName = "user-" + accountInfo?.account.accountIdentifier;
        
        return `https://${this.account}.blob.core.windows.net/${containerName}/${filename}?${this.sas}`;

      } catch (error) {
          //console.log(error);
          throw error;
      }
    }
    
    public async GetCoursesBlob(filename:string, containerName:string):Promise<string> {
      try {
        await this.GenerateCourseSARSToken();
        return `https://${this.account}.blob.core.windows.net/${containerName}/${filename}?${this.courseSas}`;

      } catch (error) {
          //console.log(error);
          throw error;
      }
    }
}



